module.exports = __webpack_public_path__ + "static/media/MainPage_4.fb503d77.png";